<template>
  <ul :class="type === 'small' ? 'w-full small-css' : 'w-full'">
    <li
      class="tr-li text-left cursor-pointer relative"
      v-for="item in bookingOffice"
      :key="item.id"
      @click="newPageJump(item)"
    >
      <span
        class="absolute ticket-icon"
        :style="`background-image: url('${item.image_url}')`"
      ></span>
      <span class="inline-block font-css">{{ item.name }}</span>
      <img
        class="arrow"
        src="../../../static/images/public/arrow-right.png"
        alt="icon"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'booking-office-component',
  props: {
    type: null
  },
  data() {
    return {}
  },
  computed: {
    bookingOffice() {
      return this.$store.getters['HomeStore/tickets']
    }
  },
  mounted: function() {},
  methods: {
    newPageJump(item) {
      window.open(item.link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.tr-li {
  height: 110px;
  line-height: 110px;
  font-weight: 300;
  color: $c-white;
  font-size: 28px;
  padding-left: 116px;
  overflow: hidden;
  -o-text-overflow: ellipsis; /* Opera 9-10 */
  text-overflow: ellipsis;
  white-space: nowrap;

  &:nth-child(4n + 1) {
    background-color: $c-tour-1;
  }
  &:nth-child(4n + 2) {
    background-color: $c-tour-2;
  }

  &:nth-child(4n + 3) {
    background-color: $c-tour-4;
  }
  &:nth-child(4n + 4) {
    background-color: $c-tour-3;
  }
  .ticket-icon {
    top: 30px;
    left: 40px;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .font-css {
    height: 46px;
    line-height: 46px;
    padding-left: 25px;
    border-left: 1.2px solid $c-white;
  }
  .arrow {
    float: right;
    margin-top: 47px;
    margin-right: 45px;
  }
}
.small-css {
  .tr-li {
    height: 88px;
    line-height: 88px;
    background-image: url('../../../static/images/public/bg-flower-g.png');
    background-repeat: no-repeat;
    background-size: auto 360px;
    background-position: 117% 0px;
    &:nth-child(4n + 2) {
      background-image: url('../../../static/images/public/bg-flower-g.png');
      background-repeat: no-repeat;
      background-size: auto 360px;
      background-position: 117% 31%;
    }
    &:nth-child(4n + 3) {
      background-color: $c-tour-bg-yellow;
      background-image: url('../../../static/images/public/bg-flower-g.png');
      background-repeat: no-repeat;
      background-size: auto 360px;
      background-position: 117% 62%;
    }
    &:nth-child(4n + 4) {
      background-color: $c-tour-4;
      background-image: url('../../../static/images/public/bg-flower-g.png');
      background-repeat: no-repeat;
      background-size: auto 360px;
      background-position: 117% 94%;
    }
  }
  .ticket-icon {
    top: 20px;
  }
  .arrow {
    display: none;
  }
}
</style>
